import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import { twMerge } from "tailwind-merge"
import { type DashboardWithTag } from "../views/types"
import { DashboardItem } from "./DashboardItem"

const SkeletonItem = () => {
  return (
    <Card
      className="rounded-md"
      style={{
        minHeight: 170,
        opacity: 0.5,
      }}
    />
  )
}

const SkeletonItems = ({ count }: { count: number }) => {
  return Array.from({ length: count }).map((_, index) => (
    <SkeletonItem key={index} />
  ))
}

type DashboardGridProps = {
  dashboards: DashboardWithTag[]
  isLoading?: boolean
  isLoggedIn: boolean
  hideCreatedBy?: boolean
  className?: string
}

export const DashboardGrid = ({
  dashboards,
  isLoading,
  isLoggedIn,
  className,
  hideCreatedBy,
}: DashboardGridProps) => {
  return (
    <div
      className={twMerge(
        "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 w-full",
        className
      )}
      style={{
        gridAutoRows: "auto",
      }}
    >
      {isLoading && <SkeletonItems count={20} />}
      {!isLoading &&
        dashboards.map((dashboard) => (
          <DashboardItem
            isLoggedIn={isLoggedIn}
            key={dashboard.user_dashboard_id}
            dashboard={dashboard}
            hideCreatedBy={hideCreatedBy}
          />
        ))}
    </div>
  )
}
